module.exports = __webpack_public_path__ + "img/i_m_btn_internet.a5fae990.svg";